// extracted by mini-css-extract-plugin
export default {"container":"switch_container__heRyn","track":"switch_track__AVjID","thumb":"switch_thumb__Cb10j","active":"switch_active__On3Qp"};